$(function() {
  var wH = $(window).height();
  var scrollend = $('#form').offset().top - wH;
  var distance = 0;
  $(document).on('scroll', function() {
    distance = $(this).scrollTop();
    if (scrollend <= distance) {
      $('.btn_float').addClass('main_bnr_none')
    } else{
      $('.btn_float').removeClass('main_bnr_none');
    }
  });
});
